var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.499,
    height: 17.499,
    viewBox: "0 0 17.499 17.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M16.955,2.129,15.369.544a1.86,1.86,0,0,0-2.628,0l-11.8,11.8a.522.522,0,0,0-.142.269L.009,16.893a.513.513,0,0,0,.6.6L4.888,16.7a.522.522,0,0,0,.269-.142l11.8-11.8A1.857,1.857,0,0,0,16.955,2.129ZM1.153,16.347l.48-2.59,2.11,2.11Zm3.642-.878L2.031,12.7,12.12,2.614l2.764,2.764ZM16.23,4.032l-.621.621L12.845,1.889l.621-.621a.834.834,0,0,1,1.178,0L16.23,2.854A.832.832,0,0,1,16.23,4.032Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d8de4eb3b13b97c6c5a229ac8a819bc8.svg";
export { ForwardRef as ReactComponent };